import { SELECT_ATTRIBUTE_TYPES } from '../constants';
import type { AttributeType } from '../types';

/**
 * Может ли атрибут с этим типом данных нести признак «список». Пока тип не выбран, признак не ограничен
 */
export const isListAllowed = (dataType?: AttributeType | string | null): boolean =>
  !SELECT_ATTRIBUTE_TYPES.some((selectType) => selectType === dataType);
